import { mapCubicBezierArrayToString } from "@styles/utils/mapCubicBezierArrayToString";

export const mapTokenTransitionToCSSTransition = (
  duration: string,
  timingFunction: number[]
): string => {
  if (Array.isArray(timingFunction)) {
    return `${duration} ${mapCubicBezierArrayToString(timingFunction)}`;
  }

  return `${duration} ${timingFunction}`;
};
